import script from "./AdminCompletedFormsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminCompletedFormsView.vue?vue&type=script&setup=true&lang=ts"

import "./AdminCompletedFormsView.vue?vue&type=style&index=0&id=6d8f3b66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d8f3b66"]])

export default __exports__